import { render, staticRenderFns } from "./projectone.vue?vue&type=template&id=1c287b68&scoped=true&"
import script from "./projectone.vue?vue&type=script&lang=js&"
export * from "./projectone.vue?vue&type=script&lang=js&"
import style0 from "./projectone.vue?vue&type=style&index=0&id=1c287b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c287b68",
  null
  
)

export default component.exports